import {useEffect} from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {FormProviderRHF, InputField, useFormRHF} from "@pg-design/rhf-components-module";
import {REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

import {validationMessages} from "../../../form/utils/validation_messages";
import {addNotification} from "../../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../../notifications/utils/error_notifications";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {isRtkqMutationError} from "../../../store/utils/is_rtkq_mutation_error";
import {usePatchUserProfileMutation} from "../../../user/api/patch_user_profile";
import {REGISTRATION_WIZARD_DEFAULT_CTA_LABEL} from "../../constants/registration_wizard_entry_content";
import {useRegistrationWizardTrackingContext} from "../../hooks/use_registration_wizard_tracking_context";
import {saveWizardDraft} from "../../state/registration_flow_slice";
import {trackRegistrationWizardButtonClick} from "../../tracking/track_registration_wizard_events";
import {UnlockChoiceEntryPoint} from "../../types/UnlockChoiceEntryPoint";
import {RegistrationWizardStepLayout} from "./RegistrationWizardStepLayout";

interface IProps {
    titleId: string;
    onAdvance: () => Promise<void>;
}

interface INameFormValues {
    name: string;
}

const nameValidationSchema = Yup.object({
    name: Yup.string().trim().required(validationMessages.required)
});

export const RegistrationWizardNameStep = (props: IProps) => {
    const {titleId, onAdvance} = props;
    const dispatch = useAppDispatch();
    const {wizardDrafts, entryCtaLabel, unlockChoiceEntryPoint} = useAppSelector((state) => state.registrationFlow);
    const [patchUserProfile] = usePatchUserProfileMutation();
    const trackingContext = useRegistrationWizardTrackingContext();
    const form = useFormRHF<INameFormValues>({
        defaultValues: {name: wizardDrafts.name ?? ""},
        resolver: yupResolver(nameValidationSchema),
        mode: "onBlur"
    });
    const {isSubmitting} = form.formState;
    const ctaLabel = (entryCtaLabel || REGISTRATION_WIZARD_DEFAULT_CTA_LABEL).toLocaleUpperCase("pl-PL");

    useEffect(() => {
        return () => {
            dispatch(saveWizardDraft({name: form.getValues("name")}));
        };
    }, []);

    const onSubmit = async (values: INameFormValues) => {
        trackRegistrationWizardButtonClick(
            trackingContext,
            unlockChoiceEntryPoint === UnlockChoiceEntryPoint.PRICE ? "rp_auth_discover_price" : "rp_auth_continue"
        );

        const response = await patchUserProfile({name: values.name.trim()});

        if (isRtkqMutationError(response)) {
            const nameError = (response.error as {data?: {name?: string[] | string}}).data?.name;

            if (nameError) {
                form.setError("name", {type: "server", message: Array.isArray(nameError) ? nameError.join(", ") : nameError});
            } else {
                dispatch(addNotification({notification: defaultAPIErrorNotification}));
            }

            return;
        }

        await onAdvance();
    };

    return (
        <RegistrationWizardStepLayout titleId={titleId} title="Jak się do Ciebie zwracać?" description="To już ostatni krok przed poznaniem ceny.">
            <FormProviderRHF {...form}>
                <form className={formStyle} onSubmit={form.handleSubmit(onSubmit)} noValidate>
                    <InputField name="name" placeholder="Twoje imię" autoComplete="given-name" dataTestId={REGISTRATION_WIZARD_TEST_IDS.NAME_INPUT} />
                    <Button
                        type="submit"
                        variant="filled_primary"
                        fullWidth
                        isLoading={isSubmitting}
                        disabled={isSubmitting}
                        dataTestId={REGISTRATION_WIZARD_TEST_IDS.NAME_SUBMIT_BUTTON}
                    >
                        {ctaLabel}
                    </Button>
                </form>
            </FormProviderRHF>
        </RegistrationWizardStepLayout>
    );
};

const formStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3
});
import {useEffect} from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {FormProviderRHF, InputField, useFormRHF} from "@pg-design/rhf-components-module";
import {REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

import {validationMessages} from "../../../form/utils/validation_messages";
import {addNotification} from "../../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../../notifications/utils/error_notifications";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {isRtkqMutationError} from "../../../store/utils/is_rtkq_mutation_error";
import {usePatchUserProfileMutation} from "../../../user/api/patch_user_profile";
import {REGISTRATION_WIZARD_DEFAULT_CTA_LABEL} from "../../constants/registration_wizard_entry_content";
import {useRegistrationWizardTrackingContext} from "../../hooks/use_registration_wizard_tracking_context";
import {saveWizardDraft} from "../../state/registration_flow_slice";
import {trackRegistrationWizardButtonClick} from "../../tracking/track_registration_wizard_events";
import {UnlockChoiceEntryPoint} from "../../types/UnlockChoiceEntryPoint";
import {RegistrationWizardStepLayout} from "./RegistrationWizardStepLayout";

interface IProps {
    titleId: string;
    onAdvance: () => Promise<void>;
}

interface INameFormValues {
    name: string;
}

const nameValidationSchema = Yup.object({
    name: Yup.string().trim().required(validationMessages.required)
});

export const RegistrationWizardNameStep = (props: IProps) => {
    const {titleId, onAdvance} = props;
    const dispatch = useAppDispatch();
    const {wizardDrafts, entryCtaLabel, unlockChoiceEntryPoint} = useAppSelector((state) => state.registrationFlow);
    const [patchUserProfile] = usePatchUserProfileMutation();
    const trackingContext = useRegistrationWizardTrackingContext();
    const form = useFormRHF<INameFormValues>({
        defaultValues: {name: wizardDrafts.name ?? ""},
        resolver: yupResolver(nameValidationSchema),
        mode: "onBlur"
    });
    const {isSubmitting} = form.formState;
    const ctaLabel = (entryCtaLabel || REGISTRATION_WIZARD_DEFAULT_CTA_LABEL).toLocaleUpperCase("pl-PL");

    useEffect(() => {
        return () => {
            dispatch(saveWizardDraft({name: form.getValues("name")}));
        };
    }, []);

    const onSubmit = async (values: INameFormValues) => {
        trackRegistrationWizardButtonClick(
            trackingContext,
            unlockChoiceEntryPoint === UnlockChoiceEntryPoint.PRICE ? "rp_auth_discover_price" : "rp_auth_continue"
        );

        const response = await patchUserProfile({name: values.name.trim()});

        if (isRtkqMutationError(response)) {
            const nameError = (response.error as {data?: {name?: string[] | string}}).data?.name;

            if (nameError) {
                form.setError("name", {type: "server", message: Array.isArray(nameError) ? nameError.join(", ") : nameError});
            } else {
                dispatch(addNotification({notification: defaultAPIErrorNotification}));
            }

            return;
        }

        await onAdvance();
    };

    return (
        <RegistrationWizardStepLayout titleId={titleId} title="Jak się do Ciebie zwracać?" description="To już ostatni krok przed poznaniem ceny.">
            <FormProviderRHF {...form}>
                <form className={formStyle} onSubmit={form.handleSubmit(onSubmit)} noValidate>
                    <InputField name="name" placeholder="Twoje imię" autoComplete="given-name" dataTestId={REGISTRATION_WIZARD_TEST_IDS.NAME_INPUT} />
                    <Button
                        type="submit"
                        variant="filled_primary"
                        fullWidth
                        isLoading={isSubmitting}
                        disabled={isSubmitting}
                        dataTestId={REGISTRATION_WIZARD_TEST_IDS.NAME_SUBMIT_BUTTON}
                    >
                        {ctaLabel}
                    </Button>
                </form>
            </FormProviderRHF>
        </RegistrationWizardStepLayout>
    );
};

const formStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3
});
